import { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import "./richInputEditor.scss";

const itemFormatter = (item) => `@${item.firstname} ${item.lastname} (${item.email})`;

// Saisie d'un commentaire : éditeur CKEditor avec mentions « @ », bouton
// d'envoi, et « Annuler » quand la page fournit `onCancel`. Sert à la saisie
// comme à la modification (`initialComment`, `submitLabel`).
function RichInputEditor({
  users = [],
  onSubmit = () => {},
  onCancel,
  initialComment = "",
  label = "Écrire un commentaire",
  placeholder = "Écrire un commentaire… (@ pour mentionner)",
  submitLabel = "Envoyer",
  autoFocus = false,
  compact = false,
}) {
  const [htmlContent, setHtmlContent] = useState(initialComment);

  const usersFeed = users
    .filter((manager) => {
      if (manager.contractEndAt) {
        return new Date(manager.contractEndAt) > new Date();
      }
      return true;
    })
    .map((manager) => ({
      id: itemFormatter(manager),
      name: `${manager.firstname} ${manager.lastname}`,
    }));

  const editorConfiguration = {
    placeholder,
    mention: {
      feeds: [
        {
          feed: usersFeed,
          marker: "@",
          minimumCharacters: 1,
        },
      ],
    },
  };

  function extractUsersFromDataMentions(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const mentionElements = doc.querySelectorAll(".mention[data-mention]");
    const dataMentions = Array.from(mentionElements).map((element) => element.getAttribute("data-mention"));
    return users.filter((manager) => dataMentions.includes(itemFormatter(manager)));
  }

  const estVide = !htmlContent || !htmlContent.replace(/<[^>]*>|&nbsp;/g, "").trim();

  const onSubmitForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (estVide) return;
    const mentionedUsers = extractUsersFromDataMentions(htmlContent);
    setHtmlContent("");
    const uniqueMentionedUsers = mentionedUsers.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
    onSubmit({
      comment: {
        text: htmlContent,
        mentionedUsers: uniqueMentionedUsers.map((m) => m.id),
      },
    });
  };

  const surClavier = (e) => {
    if (e.key === "Escape" && onCancel) {
      e.preventDefault();
      e.stopPropagation();
      onCancel();
    }
  };

  return (
    <form className={`rie${compact ? " rie--compact" : ""}`} onSubmit={onSubmitForm} onKeyDown={surClavier}>
      <div className="rie-editeur" role="group" aria-label={label}>
        <CKEditor
          editor={Editor}
          data={htmlContent}
          config={editorConfiguration}
          onChange={(_evenement, editor) => setHtmlContent(editor.getData())}
          onReady={(editor) => {
            if (autoFocus && editor) editor.editing.view.focus();
          }}
        />
      </div>
      <div className="rie-actions">
        {onCancel && (
          <button type="button" className="rie-bouton rie-bouton--lien" onClick={onCancel}>
            Annuler
          </button>
        )}
        <button type="submit" className="rie-bouton rie-bouton--primaire" disabled={estVide}>
          <i className="fa fa-paper-plane" aria-hidden="true" />
          {submitLabel}
        </button>
      </div>
    </form>
  );
}

export default RichInputEditor;
